import { Injectable } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import {firstValueFrom} from 'rxjs';
import { first } from 'rxjs/operators';

import { ImageMediaDialogComponent } from '@atmi/shared';

import { Media } from '../models/media';
import { MediaService } from '../services/media.service';
import { extractMediaTypeFromPath } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class UIMediaService {

  constructor(
    private readonly dialog: MatDialog,
    private readonly mediaService: MediaService,
  ) {
  }

  dispatchViewMediaAction(media: Media) {
    if (!media.id) {
      throw new Error('Cannot dispatch action without a concrete media. Missing id property');
    }

    switch (extractMediaTypeFromPath(media.path)) {
      case 'application/pdf':
        const mediaUrl = this.mediaService.generateBinaryUrl(media.id);
        window.open(mediaUrl, '_blank');
        break;
      default:
        this.dialog.open(ImageMediaDialogComponent, { data: { media } });
    }
  }

  async dispatchDownloadMediaAction(media: Media) {
    if (!media.id) {
      throw new Error('Cannot dispatch action without a concrete media. Missing id property');
    }
    const mediaBlob = await firstValueFrom(this.mediaService.getBinary(media.id).pipe(first()));
    saveAs(mediaBlob, media.name || `media-${media.id}`);
  }
}
